import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../styles/guest-coupon.css";

const DISMISS_KEY = "gcFabDismissedAt";
// How long the coupon stays hidden after it is closed
const SNOOZE_MS = 10 * 60 * 1000;

// Time left before a dismissed coupon shows again (0 when it should be visible)
const snoozeRemaining = () => {
  try {
    const dismissedAt = Number(localStorage.getItem(DISMISS_KEY));
    return dismissedAt ? Math.max(0, dismissedAt + SNOOZE_MS - Date.now()) : 0;
  } catch {
    return 0;
  }
};

/** Floating coupon ticket in the corner of the page, linking to the guest coupon page. */
const FloatingCouponButton = () => {
  const [hidden, setHidden] = useState(() => snoozeRemaining() > 0);

  // Bring the coupon back once the snooze runs out, even if the page stays open
  useEffect(() => {
    if (!hidden) return;
    // Falls back to a full snooze when storage is unavailable
    const timer = setTimeout(() => setHidden(false), snoozeRemaining() || SNOOZE_MS);
    return () => clearTimeout(timer);
  }, [hidden]);

  const dismiss = () => {
    try {
      localStorage.setItem(DISMISS_KEY, String(Date.now()));
    } catch {}
    setHidden(true);
  };

  if (hidden) return null;

  return (
    <div className="gc-fab">
      <Link to="/guest-coupon" className="gc-fab__link" aria-label="Claim your welcome coupon">
        <span className="gc-fab__ticket">
          <span className="gc-fab__stub">
            <span className="gc-fab__icon">
              <i className="ph ph-gift" aria-hidden="true" />
            </span>
          </span>
          <span className="gc-fab__body">
            <span className="gc-fab__label">Welcome gift</span>
            <span className="gc-fab__heading">Claim Coupon</span>
          </span>
        </span>
      </Link>
      <button type="button" className="gc-fab__close" onClick={dismiss} aria-label="Close coupon">
        <i className="ph ph-x" aria-hidden="true" />
      </button>
    </div>
  );
};

export default FloatingCouponButton;
